// extracted by mini-css-extract-plugin
export default {"column__text--truncate":"styles_column__text--truncate__BwbZD","pagination__wrapper":"styles_pagination__wrapper__eBEfH"};